import { createEncounterHistoryStore } from "@ayla/browser-state";
import type { EncounterSnapshot } from "@ayla/conversation";

export type { RollingAverages } from "@ayla/browser-state";

export const {
  HISTORY_KEY,
  HISTORY_EVT,
  HISTORY_PING_KEY,
  loadHistory,
  saveHistory,
  upsertLatest,
  removeById,
  clearAllHistory,
  rollingAvg,
} = createEncounterHistoryStore<EncounterSnapshot>({
  key: "engage:encounterHistory:v1",
  event: "engage:history:changed",
  pingKey: "engage:history:ping",
  legacyKeys: ["stetho:encounterHistory:v1"],
});

const KEY = "engage:interruptionsHistory";
const LEGACY_INTERRUPTION_KEYS = ["pm:interruptionsHistory"];

function migrateLegacyInterruptionHistory() {
  if (typeof window === "undefined") return;
  try {
    const existing = localStorage.getItem(KEY);
    if (existing) return;

    for (const legacyKey of LEGACY_INTERRUPTION_KEYS) {
      const legacyValue = localStorage.getItem(legacyKey);
      if (!legacyValue) continue;
      localStorage.setItem(KEY, legacyValue);
      return;
    }
  } catch {
    // ignore storage errors
  }
}

export function pushInterruptionCount(count: number) {
  migrateLegacyInterruptionHistory();
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? (JSON.parse(raw) as number[]) : [];
    arr.push(Math.max(0, Number(count || 0)));
    const pruned = arr.slice(-50);
    localStorage.setItem(KEY, JSON.stringify(pruned));
    try {
      localStorage.setItem(HISTORY_PING_KEY, String(Date.now()));
      window.dispatchEvent(new CustomEvent(HISTORY_EVT));
    } catch {
      // ignore storage/event errors
    }
  } catch {
    // ignore storage errors
  }
}

export function getInterruptionAverage(): number | null {
  migrateLegacyInterruptionHistory();
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const arr = JSON.parse(raw) as number[];
    if (!arr.length) return null;
    const sum = arr.reduce((a, b) => a + b, 0);
    return sum / arr.length;
  } catch {
    return null;
  }
}
